import { render, staticRenderFns } from "./ChangeUpdateChanges.vue?vue&type=template&id=335ee50a"
import script from "./ChangeUpdateChanges.vue?vue&type=script&lang=js"
export * from "./ChangeUpdateChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports